<template lang="pug">
  section#home.section(:class="{'play': isReady}" data-pv="index")
    .section__outer

    .section__inner
      h1.home__caption.move-in 用你的心跳寫歌
      p.home__text.move-in(style="transition-delay: .05s") 認真時 心跳會加速
      p.home__text.move-in(style="transition-delay: .1s") 這一次 用你的心跳聲
      p.home__text.move-in(style="transition-delay: .15s") 寫成一首心跳單曲
      p.home__text.move-in(style="transition-delay: .2s") 記錄 認真生活的自己
      a.home__button.move-in(href="#" style="transition-delay: .25s" @click.prevent="goToGamePage")

      //- transition(name="fade" mode="out-in")
      //-   .part

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mixins } from '@/utils/mixins'

export default {
  name: 'Home',
  mixins: [mixins],
  props: {
  },
  watch: {
    popup(newValue, oldValue) {
      if ((oldValue && oldValue.type === 'ring')) {
        setTimeout(() => {
          this.init();
        }, 500);
      }
    },
    isLoading() {
      if (!this.isLoading && !this.isReady) {
        this.init();
      }
    },
  },
  data: () => {
    return {
      isReady: false,
    }
  },
  computed: {
    ...mapState(['isLoading', 'isMobile', 'popup']),
  },
  methods: {
    ...mapActions(['openPopup']),
    init() {
      this.isReady = true;
    },
    goToGamePage() {
      const { isProduction } = this;
      if (isProduction()) {
        const isMedialand = window.location.href.indexOf('medialand') >= 0;
        if (isMedialand) {
          this.$router.push('/game');
          this.$trackEvent('index', 'click_button', 'index_start');
        } else {
          this.$trackEvent('index', 'click_button', 'index_start', function() {
            location.href = `${process.env.VUE_APP_SITE}#/game`;
          });
        }
      } else {
        this.$router.push('/game');
        this.$trackEvent('index', 'click_button', 'index_start');
      }
    },
    // goToNextPage() {
    //   this.$router.push('/next');
    // },
  },
  created() {
  },
  mounted() {
    const { init, isLoading, isReady } = this;
    if (!isLoading && !isReady) setTimeout(init, 500);
    this.$trackPage('index');
    // setTimeout(() => { if (!isLoading) init() }, 1000)
    // if (this.isMobile) this.openPopup({ type: 'ring' })
  },
  destroyed() {
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/home/';

#home {

  height: calc(var(--vh, 1vh) * 100);
  min-height: vw(1250 + 54);
  overflow: hidden;

  @include desktop {
    height: calc(var(--vh, 1vh) * 100);
  }

  .section__inner {

    // position: relative;

    @include desktop {
      height: 100%;
    }

  }

  .home__caption {
    position: absolute;
    top: vw(336);
    left: vw(88);
    width: vw(563);
    height: vw(304);
    background: url($assets + 'caption.png') no-repeat 0 0 / contain;
    @include hide-text;
  }

  .home__text {
    position: absolute;
    left: 0;
    width: 100%;
    color: #fff;
    font-size: vw(26);
    // font-weight: 400;
    text-align: center;
    letter-spacing: vw(letterSpacing(200, 26));
    line-height: 1;

    &:nth-of-type(1) {
      top: vw(685);
    }

    &:nth-of-type(2) {
      top: vw(728);
    }
    
    &:nth-of-type(3) {
      top: vw(771);
    }

    &:nth-of-type(4) {
      top: vw(814);
    }

  }

  .home__button {
    position: absolute;
    top: vw(897);
    left: vw(247);
    width: vw(258);
    height: vw(258);
    background: url($assets + 'button.png') no-repeat 0 0 / contain;
    // transition: filter .15s linear;

    &::after {
      content: '';
      position: absolute;
      top: vw(146);
      left: vw(107);
      width: vw(43);
      height: vw(35);
      background: url($assets + 'button-arrow.png') no-repeat 0 0 / contain;
      animation: buttonArrow 1s ease-in-out infinite;
    }

    // @include hover {
      &:hover {
        filter: brightness(2);
        // transform: scale(1.1);
      }
    // }
  }

  @keyframes buttonArrow {
    0%, 100% {
      transform: translateY(20%);
    }
    50% {
      transform: translateY(5%);
    }
  }

}

</style>
